export const comics = [
  {
    id: 1,
    title: '全球诡异时代',
    slug: 'global-strange-era',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20manga%20cover%20art%2C%20shadowy%20figure%20standing%20in%20foggy%20alley%2C%20red%20and%20black%20color%20scheme%2C%20horror%20manga%20style%2C%20dramatic%20lighting%2C%20detailed%20illustration%2C%20clean%20composition%2C%20professional%20comic%20cover%20design%20with%20bold%20title%20area%2C%20dark%20atmospheric%20background&width=800&height=1100&seq=comic-cover-01&orientation=portrait',
    author: '墨渊',
    status: '连载中',
    category: '悬疑',
    rating: 9.6,
    views: 12850000,
    description: '一场突如其来的全球诡异事件席卷世界，普通高中生林夜在诡异降临后觉醒了特殊能力。他必须在充满未知恐惧的新世界中生存下去，揭开诡异背后的惊天秘密。',
    chapters: [
      { id: 1, title: '第1话 诡异降临', number: 1, updatedAt: '2026-07-08' },
      { id: 2, title: '第2话 觉醒', number: 2, updatedAt: '2026-07-07' },
      { id: 3, title: '第3话 初次战斗', number: 3, updatedAt: '2026-07-06' },
      { id: 4, title: '第4话 同伴', number: 4, updatedAt: '2026-07-05' },
      { id: 5, title: '第5话 诡异之影', number: 5, updatedAt: '2026-07-04' },
      { id: 6, title: '第6话 真相浮现', number: 6, updatedAt: '2026-07-03' },
      { id: 7, title: '第7话 午夜追踪', number: 7, updatedAt: '2026-07-02' },
      { id: 8, title: '第8话 暗潮涌动', number: 8, updatedAt: '2026-07-01' },
    ],
    isHot: true,
    isNew: false,
    tags: ['悬疑', '恐怖', '超能力', '异能'],
  },
  {
    id: 2,
    title: '末日求生指南',
    slug: 'doomsday-survival-guide',
    cover: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20manga%20cover%2C%20survivor%20with%20weapon%20in%20ruined%20cityscape%2C%20warm%20orange%20and%20dark%20gray%20tones%2C%20action%20adventure%20comic%20style%2C%20dramatic%20composition%2C%20detailed%20background%20with%20destroyed%20buildings%2C%20professional%20manga%20cover%20design&width=800&height=1100&seq=comic-cover-02&orientation=portrait',
    author: '寒风',
    status: '连载中',
    category: '冒险',
    rating: 9.3,
    views: 8920000,
    description: '末世降临，丧尸横行。普通上班族陈默凭借一本神秘的《末日求生指南》，在废墟中建立避难所，带领幸存者对抗丧尸潮，寻找传说中的安全区。',
    chapters: [
      { id: 9, title: '第1话 末日第一天', number: 1, updatedAt: '2026-07-08' },
      { id: 10, title: '第2话 求生指南', number: 2, updatedAt: '2026-07-07' },
      { id: 11, title: '第3话 避难所', number: 3, updatedAt: '2026-07-06' },
    ],
    isHot: true,
    isNew: false,
    tags: ['冒险', '末世', '丧尸', '生存'],
  },
  {
    id: 3,
    title: '剑仙在此',
    slug: 'sword-immortal-here',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20manhua%20cover%2C%20swordsman%20in%20flowing%20white%20robes%20surrounded%20by%20floating%20swords%2C%20ethereal%20atmosphere%2C%20ancient%20Chinese%20fantasy%20art%20style%2C%20soft%20golden%20and%20white%20color%20palette%2C%20dramatic%20cloud%20background%2C%20professional%20comic%20cover&width=800&height=1100&seq=comic-cover-03&orientation=portrait',
    author: '云中子',
    status: '连载中',
    category: '奇幻',
    rating: 9.5,
    views: 15600000,
    description: '少年李青云意外获得上古剑仙传承，从此踏上修仙之路。在灵气复苏的时代，他以一剑破万法，斩妖除魔，成为这个时代最强的剑仙。',
    chapters: [
      { id: 12, title: '第1话 剑仙传承', number: 1, updatedAt: '2026-07-08' },
      { id: 13, title: '第2话 初入仙门', number: 2, updatedAt: '2026-07-07' },
      { id: 14, title: '第3话 筑基', number: 3, updatedAt: '2026-07-06' },
      { id: 15, title: '第4话 下山', number: 4, updatedAt: '2026-07-05' },
    ],
    isHot: true,
    isNew: false,
    tags: ['奇幻', '修仙', '热血', '战斗'],
  },
  {
    id: 4,
    title: '午夜理发店',
    slug: 'midnight-barbershop',
    cover: 'https://readdy.ai/api/search-image?query=Horror%20manga%20cover%2C%20creepy%20barbershop%20at%20night%20with%20red%20neon%20sign%2C%20mysterious%20barber%20silhouette%2C%20dark%20atmosphere%2C%20psychological%20horror%20style%2C%20blood%20red%20and%20black%20color%20scheme%2C%20ominous%20mood%2C%20professional%20comic%20cover%20design&width=800&height=1100&seq=comic-cover-04&orientation=portrait',
    author: '夜不语',
    status: '已完结',
    category: '恐怖',
    rating: 9.1,
    views: 6450000,
    description: '深夜里一家不起眼的理发店，每个走进的客人都带着不为人知的秘密。理发师手中的剪刀，剪去的不只是头发，还有那些人内心深处的恐惧。',
    chapters: [
      { id: 16, title: '第1话 第一位客人', number: 1, updatedAt: '2026-06-15' },
      { id: 17, title: '第2话 镜中人', number: 2, updatedAt: '2026-06-14' },
    ],
    isHot: false,
    isNew: false,
    tags: ['恐怖', '悬疑', '心理', '惊悚'],
  },
  {
    id: 5,
    title: '星际流浪者',
    slug: 'star-wanderer',
    cover: 'https://readdy.ai/api/search-image?query=Sci%20fi%20manga%20cover%2C%20space%20explorer%20in%20futuristic%20armor%20with%20galaxy%20background%2C%20neon%20blue%20and%20dark%20space%20colors%2C%20adventure%20comic%20style%2C%20spaceship%20and%20alien%20planet%20elements%2C%20dramatic%20lighting%2C%20professional%20comic%20cover%20design&width=800&height=1100&seq=comic-cover-05&orientation=portrait',
    author: '星河',
    status: '连载中',
    category: '科幻',
    rating: 9.4,
    views: 10100000,
    description: '公元3026年，人类已遍布银河系。年轻的星际冒险家苏辰驾驶着他那艘破旧飞船，在各星球之间穿梭，发现了一个足以改变人类命运的古老文明遗迹。',
    chapters: [
      { id: 18, title: '第1话 启程', number: 1, updatedAt: '2026-07-07' },
      { id: 19, title: '第2话 遗迹', number: 2, updatedAt: '2026-07-06' },
      { id: 20, title: '第3话 守卫者', number: 3, updatedAt: '2026-07-05' },
    ],
    isHot: false,
    isNew: true,
    tags: ['科幻', '星际', '冒险', '机甲'],
  },
  {
    id: 6,
    title: '九尾妖狐传',
    slug: 'nine-tailed-fox',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20fantasy%20manhua%20cover%2C%20beautiful%20nine%20tailed%20fox%20spirit%20woman%20in%20traditional%20Chinese%20robe%2C%20cherry%20blossom%20and%20moon%20background%2C%20soft%20pink%20and%20silver%20color%20palette%2C%20romantic%20fantasy%20style%2C%20ethereal%20atmosphere%2C%20professional%20comic%20cover&width=800&height=1100&seq=comic-cover-06&orientation=portrait',
    author: '白浅浅',
    status: '连载中',
    category: '奇幻',
    rating: 9.2,
    views: 7340000,
    description: '修行千年的九尾妖狐白灵儿，为报恩情化身凡人来到人间。在繁华都市中，她遇见了那个千年前救过她的凡人转世，一段跨越千年的奇幻爱情故事就此展开。',
    chapters: [
      { id: 21, title: '第1话 千年之约', number: 1, updatedAt: '2026-07-08' },
      { id: 22, title: '第2话 都市相遇', number: 2, updatedAt: '2026-07-07' },
    ],
    isHot: false,
    isNew: false,
    tags: ['奇幻', '爱情', '妖狐', '转世'],
  },
  {
    id: 7,
    title: '热血篮球少年',
    slug: 'hot-blood-basketball',
    cover: 'https://readdy.ai/api/search-image?query=Sports%20manga%20cover%2C%20basketball%20player%20jumping%20for%20dunk%20in%20dynamic%20pose%2C%20bright%20orange%20and%20blue%20colors%2C%20action%20packed%20composition%2C%20gymnasium%20background%20with%20crowd%2C%20energetic%20sports%20comic%20style%2C%20professional%20cover%20design&width=800&height=1100&seq=comic-cover-07&orientation=portrait',
    author: '林动',
    status: '连载中',
    category: '热血',
    rating: 9.0,
    views: 5670000,
    description: '身高只有168cm的少年陈飞，凭借惊人的弹跳力和永不言弃的精神，带领垫底球队一路杀入全国大赛。他要用实力证明，篮球不止是高个子的运动！',
    chapters: [
      { id: 23, title: '第1话 小个子的大梦想', number: 1, updatedAt: '2026-07-08' },
      { id: 24, title: '第2话 第一次上场', number: 2, updatedAt: '2026-07-07' },
    ],
    isHot: false,
    isNew: true,
    tags: ['热血', '运动', '篮球', '青春'],
  },
  {
    id: 8,
    title: '灵异事件调查局',
    slug: 'paranormal-investigation',
    cover: 'https://readdy.ai/api/search-image?query=Mystery%20manga%20cover%2C%20detective%20team%20in%20dark%20office%20with%20case%20files%20and%20strange%20artifacts%2C%20moody%20noir%20lighting%2C%20supernatural%20investigation%20theme%2C%20green%20and%20dark%20gray%20tones%2C%20atmospheric%20mystery%20comic%20style%2C%20professional%20cover&width=800&height=1100&seq=comic-cover-08&orientation=portrait',
    author: '唐探',
    status: '连载中',
    category: '悬疑',
    rating: 9.3,
    views: 8230000,
    description: '国家秘密部门"灵异事件调查局"专门处理各地发生的超自然事件。新人探员周远加入后，发现每一个案件背后都隐藏着一个更大的阴谋。',
    chapters: [
      { id: 25, title: '第1话 新人报到', number: 1, updatedAt: '2026-07-06' },
      { id: 26, title: '第2话 第一案', number: 2, updatedAt: '2026-07-05' },
      { id: 27, title: '第3话 线索', number: 3, updatedAt: '2026-07-04' },
    ],
    isHot: false,
    isNew: false,
    tags: ['悬疑', '灵异', '推理', '探案'],
  },
  {
    id: 9,
    title: '美食猎人',
    slug: 'food-hunter',
    cover: 'https://readdy.ai/api/search-image?query=Food%20adventure%20manga%20cover%2C%20cheerful%20chef%20with%20exotic%20ingredients%20in%20fantasy%20world%2C%20delicious%20dishes%20with%20magical%20glow%2C%20warm%20golden%20and%20brown%20colors%2C%20adventure%20cooking%20comic%20style%2C%20beautiful%20food%20illustration%2C%20professional%20cover&width=800&height=1100&seq=comic-cover-09&orientation=portrait',
    author: '味觉大师',
    status: '已完结',
    category: '冒险',
    rating: 8.9,
    views: 4120000,
    description: '在美食至上的奇幻世界里，少年厨师方元踏上寻找传说中"神之食材"的旅程。沿途他不仅收集到了各种珍稀食材，更领悟到了烹饪的真谛。',
    chapters: [
      { id: 28, title: '第1话 出发', number: 1, updatedAt: '2026-05-20' },
      { id: 29, title: '第2话 第一个食材', number: 2, updatedAt: '2026-05-19' },
    ],
    isHot: false,
    isNew: false,
    tags: ['冒险', '美食', '奇幻', '旅行'],
  },
  {
    id: 10,
    title: '机甲战士：铁穹',
    slug: 'mecha-warrior-iron-dome',
    cover: 'https://readdy.ai/api/search-image?query=Mecha%20manga%20cover%2C%20giant%20robot%20in%20epic%20battle%20pose%20against%20city%20skyline%2C%20metallic%20and%20fiery%20orange%20colors%2C%20sci%20fi%20war%20theme%2C%20detailed%20mechanical%20design%2C%20explosive%20action%20scene%2C%20professional%20comic%20cover&width=800&height=1100&seq=comic-cover-10&orientation=portrait',
    author: '铁血',
    status: '连载中',
    category: '科幻',
    rating: 9.4,
    views: 9780000,
    description: '外星入侵者降临地球，人类最后的希望——机甲部队"铁穹"挺身而出。少年驾驶员雷明驾驶着父亲留下的传奇机甲，为守护人类而战。',
    chapters: [
      { id: 30, title: '第1话 入侵', number: 1, updatedAt: '2026-07-08' },
      { id: 31, title: '第2话 铁穹出击', number: 2, updatedAt: '2026-07-07' },
      { id: 32, title: '第3话 初战', number: 3, updatedAt: '2026-07-06' },
    ],
    isHot: true,
    isNew: false,
    tags: ['科幻', '机甲', '热血', '战争'],
  },
  {
    id: 11,
    title: '校园诡话',
    slug: 'campus-ghost-stories',
    cover: 'https://readdy.ai/api/search-image?query=School%20horror%20manga%20cover%2C%20students%20in%20empty%20school%20hallway%20at%20night%2C%20ghostly%20apparition%2C%20blue%20moonlight%20and%20dark%20shadows%2C%20Japanese%20school%20setting%2C%20creepy%20atmosphere%2C%20youth%20horror%20comic%20style%2C%20professional%20cover&width=800&height=1100&seq=comic-cover-11&orientation=portrait',
    author: '夜不语',
    status: '连载中',
    category: '恐怖',
    rating: 8.8,
    views: 5230000,
    description: '育才高中流传着七大不可思议的校园传说。转学生苏晓楠在入学第一天就遭遇了其中一件诡异事件，从此被卷入了一系列超乎想象的恐怖经历。',
    chapters: [
      { id: 33, title: '第1话 第七个传说', number: 1, updatedAt: '2026-07-05' },
      { id: 34, title: '第2话 旧校舍', number: 2, updatedAt: '2026-07-04' },
    ],
    isHot: false,
    isNew: false,
    tags: ['恐怖', '校园', '灵异', '传说'],
  },
  {
    id: 12,
    title: '斗罗之武魂觉醒',
    slug: 'doula-awakening',
    cover: 'https://readdy.ai/api/search-image?query=Martial%20arts%20fantasy%20manhua%20cover%2C%20warrior%20with%20glowing%20spirit%20beast%20behind%2C%20ancient%20Chinese%20setting%2C%20dynamic%20action%20pose%2C%20golden%20and%20crimson%20colors%2C%20epic%20battle%20atmosphere%2C%20professional%20comic%20cover&width=800&height=1100&seq=comic-cover-12&orientation=portrait',
    author: '武魂殿',
    status: '连载中',
    category: '热血',
    rating: 9.5,
    views: 18900000,
    description: '在这个人人拥有武魂的世界里，少年唐辰觉醒了传说中的双生武魂。从最底层一步步攀登，他要成为这片大陆上最强的魂师！',
    chapters: [
      { id: 35, title: '第1话 觉醒之日', number: 1, updatedAt: '2026-07-08' },
      { id: 36, title: '第2话 双生武魂', number: 2, updatedAt: '2026-07-07' },
      { id: 37, title: '第3话 初战魂兽', number: 3, updatedAt: '2026-07-06' },
      { id: 38, title: '第4话 魂师学院', number: 4, updatedAt: '2026-07-05' },
    ],
    isHot: true,
    isNew: false,
    tags: ['热血', '奇幻', '武魂', '战斗'],
  },
];

export const getComicBySlug = (slug: string) => {
  return comics.find((c) => c.slug === slug) || null;
};

export const getComicsByCategory = (category: string) => {
  if (!category || category === '全部') return comics;
  return comics.filter((c) => c.category === category);
};

export const getHotComics = () => comics.filter((c) => c.isHot);

export const getNewComics = () => comics.filter((c) => c.isNew);

export const getComicById = (id: number) => {
  return comics.find((c) => c.id === id) || null;
};